import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import tabRoutes from "./tab-routes";
import { Tabs } from "components";
import HomeGreetingPopup from "./popups/HomeGreeting/HomeGreetingPopup";
import { useSelector } from "react-redux";

const popups = [
  {
    title: "+ New Home Greeting",
    path: "home-greeting",
    component: closeModal => <HomeGreetingPopup closeModal={closeModal} />
  }
];

const Users = () => {
  const location = useLocation();
  const currentLocation = location.pathname.split("/", 3)[2];

  const userRole = useSelector(state =>
    state.userRole?.filter(role => role.module === "Home Greeting")
  );

  // States
  const [modal, setModal] = useState(); // Popup open or close state

  return (
    <>
      {/* Panels */}
      <Tabs
        routes={tabRoutes}
        title={popups.find(popup => currentLocation === popup.path)?.title}
        onClick={
          userRole?.find(item => item.privilege === "Create")
            ? () => setModal(currentLocation)
            : null
        }
      />

      {
        // Popups
        modal &&
          popups?.length &&
          popups.map(
            popup =>
              currentLocation === popup.path &&
              popup.component(() => setModal(false))
          )
      }
    </>
  );
};

export default Users;
